import { API_CONFIG } from '../config/api';
import { ApiClient } from './api';

// Dedicated API client for BFF endpoints
const BFF_CONFIG = {
  baseURL: (import.meta.env as any).VITE_BFF_BASE_URL || '/bff',
  timeout: API_CONFIG.timeout,
  retryAttempts: API_CONFIG.retryAttempts,
  retryDelay: API_CONFIG.retryDelay,
  headers: API_CONFIG.headers,
};

export const apiClientBff = new ApiClient(BFF_CONFIG);
